import "react-app-polyfill/ie11";
import "./styles/style.scss";

import { Buffer } from "buffer";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";

// import * as Sentry from "@sentry/react";
// import { BrowserTracing } from "@sentry/tracing";

import apiClient from "./constants/apiClient";
import { msalInstance } from "./msal-instance";
import { initStore } from "./store";

import App from "./components/App";

import { StoreProvider } from "./components/Helper/StoreProvider";

// Sentry.init({
//     dsn: "https://a3dda5aeaa77469fb5052a26bd93acc0@o1199567.ingest.sentry.io/6323348",
//     integrations: [new BrowserTracing()],

//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     enabled: process.env.NODE_ENV !== "development",
//     tracesSampleRate: 1.0,
// });

// Polyfills needed by @react-pdf/renderer (4.x) in the browser
// (CRA/Webpack 5 no longer auto-polyfills Node globals)
if (!(globalThis as any).Buffer) {
    (globalThis as any).Buffer = Buffer;
}

const container = document.getElementById("root") || document.createElement("div");
const root = createRoot(container);
initStore(apiClient);
root.render(<React.StrictMode>
    <StoreProvider>
        <Router>
            <App pca={msalInstance} />
        </Router>
    </StoreProvider>
</React.StrictMode >);

// Service-worker registration is owned by <OfflineServiceWorker /> (mounted
// inside <ConfigProvider> in RequireAuth.tsx). It registers the SW only
// when `enable_offline_checks` is true on the authenticated tenant, and
// unregisters otherwise. We deliberately do NOT touch the SW here because
// the gate depends on `useConfig()`, which is only available inside React.
// See docs/designs/EFQ-2962/...-design.md §5.1 for the rationale.
